<template>
  <google-unit v-if="unitDisplay === 'google'" :ad-id="googleUnitId" :type="type" />
  <fb-unit v-else-if="unitDisplay === 'fitnessblender'" :unit-slot-id="unitSlotId" :type="type" />
</template>

<script>
import { mapState } from 'pinia'
import { useUnitsStore } from '@/stores/units'
import { useUserAuthStore } from '@/stores/user-auth'
import GoogleUnit from '@/components/units/google-unit.vue'
import FbUnit from '@/components/units/fb-unit.vue'
import { compareFloats } from '@/utils/helpers'

/**
 * Show marketing units. Supports
 * - Google
 * - FB Units
 */
export default {
  name: 'Unit',
  components: { FbUnit, GoogleUnit },
  props: {
    unitSlotId: {
      type: Number,
      required: true,
    },
    googleUnitId: {
      type: String,
      default: '1334371830',
    },
    // TODO: gdpr v2 clean up when doing fb units
    type: {
      type: String,
      required: true,
      validator: (val) =>
        ['card-grid', 'leader-in-content', 'leader-top', 'leader-list', 'sidebar'].includes(val),
    },
  },
  data() {
    return {
      unitDisplay: '',
    }
  },
  computed: {
    ...mapState(useUserAuthStore, ['consents']),
    ...mapState(useUnitsStore, ['unitSlotPercents', 'isUnitPreview']),
  },
  watch: {
    // TODO: unit re-comment out
    // allow google units to load once storage consent is set
    'consents.STORAGE_ADS'(newConsent, prevConsent) {
      // console.warn(`UNIT ${this.unitSlotId} watcher consents.STORAGE_ADS`, newConsent, prevConsent)
      if (newConsent !== prevConsent) {
        this.determineUnitType()
      }
    },
  },
  mounted() {
    // wait for cookiebanner to settle
    setTimeout(() => this.determineUnitType(), 100)
  },

  methods: {
    determineUnitType() {
      // fb admin preview, force FB units
      if (this.isUnitPreview) {
        // console.log(`UNIT ${this.unitSlotId} determineUnitType: fb admin`)
        this.unitDisplay = 'fitnessblender'
        return
      }

      // if user has opted out of storage consent, show FB units
      if (!this.consents.STORAGE_ADS) {
        // console.log(`UNIT ${this.unitSlotId} determineUnitType: no consent`)
        this.unitDisplay = 'fitnessblender'
        return
      }

      // extract percent that FB internal unit might be shown for passed in slot id
      const unitSlotPercent =
        this.unitSlotPercents && this.unitSlotPercents[this.unitSlotId]
          ? this.unitSlotPercents[this.unitSlotId]
          : '0.00'

      // only show FB units if user doesn't have consent, percentage is 100%
      if (`${unitSlotPercent}` === '1.00') {
        // console.log(`UNIT ${this.unitSlotId} determineUnitType: 100% fb unit`)
        this.unitDisplay = 'fitnessblender'
        return
      }

      // assume we have storage consent from this point

      // default to google if percentage is 0, no math needed
      if (`${unitSlotPercent}` === '0.00') {
        // console.log(`UNIT ${this.unitSlotId} determineUnitType: 0% fb unit`)
        this.unitDisplay = 'google'
        return
      }

      // very simple random number and compare with
      const rand = Math.random()
      // console.log(
      //   'UNIT PERCENT',
      //   unitSlotPercent,
      //   rand,
      //   compareFloats(`${rand}`, '<', `${unitSlotPercent}`),
      // )

      if (compareFloats(`${rand}`, '<', `${unitSlotPercent}`)) {
        // console.log(`UNIT ${this.unitSlotId} determineUnitType: ${rand} < ${unitSlotPercent} show fb unit`)
        this.unitDisplay = 'fitnessblender'
        return
      }

      // default to google
      // console.log(`UNIT ${this.unitSlotId} determineUnitType: ${rand} < ${unitSlotPercent} default show google unit`)
      this.unitDisplay = 'google'
    },
  },
}
</script>
